<template>
    <div class="c-app">
        <Sidebar :is-authenticated="true"/>
        <CWrapper>
            <Header :is-authenticated="true"/>
            <div class="c-body">
                <main class="c-main">
                    <CContainer fluid>
                        <transition name="fade">
                            <section>
                                <slot></slot>
                            </section>
                        </transition>
                    </CContainer>
                </main>
                <Footer/>
            </div>
        </CWrapper>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import Sidebar from '@/components/Sidebar'
    import authenticatedView from "@/mixins/authenticated-view"

    export default {
        mixins: [authenticatedView],
        components: {
            Header,
            Footer,
            Sidebar
        }
    }
</script>
